import { render, staticRenderFns } from "./reviewFeedbackRubric.vue?vue&type=template&id=1af59a38&lang=html&"
import script from "./reviewFeedbackRubric.vue?vue&type=script&lang=ts&"
export * from "./reviewFeedbackRubric.vue?vue&type=script&lang=ts&"
import style0 from "./reviewFeedbackRubric.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports